import { render, staticRenderFns } from "./ownerQuitDetails.vue?vue&type=template&id=80453a94&scoped=true&"
import script from "./ownerQuitDetails.vue?vue&type=script&lang=js&"
export * from "./ownerQuitDetails.vue?vue&type=script&lang=js&"
import style0 from "./ownerQuitDetails.vue?vue&type=style&index=0&id=80453a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80453a94",
  null
  
)

export default component.exports